import React, { FC, useContext } from 'react';

import CircleCheckFill from '@gravity-ui/icons/CircleCheckFill';
import { Button, Icon } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { getDisplayDraftStatus } from 'client/blocks-redesign/statuses/OperationStatus/OperationStatus';
import { CurrentAliceAppContext } from 'client/context/aliceAppContext';
import { useSkillIsDraft } from 'client/hooks/useIsDraft';
import { OperationType } from 'client/model/operation';
import { InstallableApp, Skill } from 'client/model/skill';
import * as keyset from 'i18n/DraftsStatuses';

import { getDraftIcon } from './DeploymentStatus';
import styles from './DeploymentStatus.module.scss';

const t = i18n(keyset);

interface Props {
    skill: InstallableApp | Skill;
}

export const SkillDeploymentStatus: FC<Props> = ({ skill }) => {
    const { lastOperationType = OperationType.SkillCreated } = useContext(CurrentAliceAppContext)!;
    const { isDraft, setIsDraft } = useSkillIsDraft(skill.id);

    let publishedCard = null;

    if (skill.onAir) {
        publishedCard = (
            <Button
                className={clx(styles.statusContainer, !isDraft && styles.statusContainer_activeRoute)}
                onClick={() => setIsDraft(false)}
                view="flat"
            >
                <div className={styles.row__content}>
                    <Icon className={styles.fillGreen} data={CircleCheckFill} />
                    <span className={styles.publishedLabel__short}>{t('published-short')}</span>
                    <span className={styles.publishedLabel__long}>{t('published-long')}</span>
                </div>
            </Button>
        );
    }

    return (
        <div className={styles.container}>
            {publishedCard}
            <Button
                className={clx(styles.statusContainer, isDraft && styles.statusContainer_activeRoute)}
                onClick={() => setIsDraft(true)}
                view="flat"
            >
                <div className={styles.row__content}>
                    {getDraftIcon(getDisplayDraftStatus(true, skill.onAir, skill.draft.status, lastOperationType))}
                    {t('draft')}
                </div>
            </Button>
        </div>
    );
};
